import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import CheckboxNormal from 'components/ui/CheckboxNormal';

const TenantDamaged = ({ setFieldValue, value, disabled }) => (
  <CheckboxNormal
    name="is_tenant_damaged"
    value={value}
    checked={value}
    onChange={e => setFieldValue('is_tenant_damaged', e.target.checked)}
    style={{ marginLeft: 0, marginRight: 0 }}
    disabled={disabled}
  >
    {getTranslatedString('landlordPortal.editMaintenanceTicketForm.tenantDamaged')}
  </CheckboxNormal>
);

export default TenantDamaged;
